type PosPickState = {
  active: boolean;
  expectedBodyUuid: string | null;
};

let state: PosPickState = {
  active: false,
  expectedBodyUuid: null,
};

export function getPosPickState(): PosPickState {
  return state;
}

export function activatePosPick(expectedBodyUuid: unknown) {
  const uuid = String(expectedBodyUuid || "").trim();
  state = {
    active: true,
    expectedBodyUuid: uuid || null,
  };
}

export function deactivatePosPick() {
  state = {
    ...state,
    active: false,
  };
}
